import cmsClient from "src/services/cmsClient";
import { requireFreshSignIn, signOutOfEntra } from "./tokenRejection";

/** How long sign-out waits for the API before going on to Entra regardless. */
export const SIGN_OUT_API_TIMEOUT_MS = 3000;

/**
 * Signs the user out. Entra's sign-out leaves the tokens it has already issued
 * working until they expire, so the API is told first to stop accepting this
 * session's tokens. A failed or slow call never blocks sign-out; the session's
 * tokens then just stay valid until they expire, as they did before.
 *
 * In the mobile app's web view the API call is skipped: the token there is the
 * app's own, and revoking it would sign the app out from underneath it.
 *
 * The next sign-in in this tab is made a fresh one: Entra's sign-out page only
 * ends the browser's Entra session once the user picks an account on it, and a
 * user who leaves it instead would otherwise sign straight back in to the
 * signed-out session and be refused.
 */
export async function signOut(): Promise<void> {
	if (!window.ReactNativeWebView) {
		try {
			await cmsClient.post("/auth/sign-out/", undefined, {
				timeout: SIGN_OUT_API_TIMEOUT_MS
			});
		} catch {
			// Deliberately ignored; see above.
		}
	}
	requireFreshSignIn();
	await signOutOfEntra();
}
